export { SlotStaticData } from './slot-static-data';
